import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/expired-link/')({
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    await context.getInstance('i18n', '@myn/guest');

    const title = i18n.t('Your invitation has expired | MINT');
    return { title };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
